import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
//import posthogPlugin from "./plugins/posthog";
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.min.css'
import version from './version';

Vue.prototype.$version = version;

Vue.config.productionTip = false

//Vue.use(posthogPlugin);
//Object.defineProperty(Vue.prototype, "$posthogg", { value: posthog });

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
